import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { LoadingOutlined } from '@ant-design/icons';
import getComponents from 'utils/ComponentOverride';

export const CustomWrapper = ({ status, errorComponent, loaderComponent, wrappedComponent, ...restprops }) => {
    const { component: LoaderComponent, props: loaderProps } = loaderComponent;
    const { component: ErrorComponent, props: errorProps } = errorComponent;
    const Component = wrappedComponent;
    return (<>
        {(status === 'pending' || status === 'error') && <Stack
            flex={1}
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            style={{ height: 'inherit' }}
        >
            {status === 'error' ?
                <>
                    <ErrorComponent {...errorProps} />
                </>
                :
                <LoaderComponent {...loaderProps} />}
        </Stack>
        }
        {status === 'success' && (<Component {...restprops} />)}
    </>)
}

CustomWrapper.propTypes = {
    status: PropTypes.oneOf(["idle", "pending", "success", "error"]).isRequired,
    errorComponent: PropTypes.shape({ component: PropTypes.elementType.isRequired, props: PropTypes.object }).isRequired,
    loaderComponent: PropTypes.shape({ component: PropTypes.elementType.isRequired, props: PropTypes.object }).isRequired,
    wrappedComponent: PropTypes.elementType.isRequired
}

export const CustomError = (props) => {
    return <div {...props}>Oops something went wrong</div>
}

export const CustomLoader = (props) => {
    return <LoadingOutlined {...props} style={{ ...props?.style, fontSize: '36px', color: '#08c' }} />
}

const defaultComponents = {
    WrapperComponent: CustomWrapper,
    ErrorComponent: CustomError,
    LoaderComponent: CustomLoader
}

const withLoader = (Component, overrides = {}) => {

    const {
        WrapperComponent: {
            component: WrapperComponent
        },
        ErrorComponent,
        LoaderComponent
    } = getComponents(defaultComponents, overrides)


    return props => {
        const { status = "success", ...restprops } = props;
        return (
            <WrapperComponent status={status} errorComponent={ErrorComponent} loaderComponent={LoaderComponent} wrappedComponent={Component} {...restprops} />
        )
    }
}

export default withLoader;